import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/icons/plus.svg'
import _imports_1 from '@/assets/icons/more.svg'


const _hoisted_1 = { class: "flex flex-col w-3/4 bg-white shadow rounded-2xl p-8" }
const _hoisted_2 = { class: "flex flex-row justify-between items-center pb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Account members", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Invite account member")
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "h-px bg-gray-200 w-full mb-4"
}
const _hoisted_8 = { class: "grid grid-cols-3 items-center" }
const _hoisted_9 = { class: "text-gray-500 text-center" }
const _hoisted_10 = { class: "flex flex-row justify-end items-center" }
const _hoisted_11 = { class: "text-gray-500 mr-8 capitalize" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", { class: "rounded px-4 py-2" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col mt-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_InviteMembersModal = _resolveComponent("InviteMembersModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal = true)),
        class: "btn-filled-sm bg-primary text-white rounded-full p-4"
      }, _hoisted_5)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.error)
            ? (_openBlock(), _createBlock(_component_ErrorState, { key: 0 }))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.members, (member, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "mt-4"
                }, [
                  (i > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_UserCard, {
                      firstName: member.first_name,
                      lastName: member.last_name
                    }, null, 8, ["firstName", "lastName"]),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(member.email), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(member.role), 1),
                      _hoisted_12
                    ])
                  ])
                ]))
              }), 128))
        ])),
    _hoisted_13,
    _createVNode(_component_InviteMembersModal, {
      openModal: _ctx.openModal,
      "onUpdate:openModal": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.openModal) = $event))
    }, null, 8, ["openModal"])
  ]))
}